module.exports = __webpack_public_path__ + "img/kdz-icon.91c892d6.png";